import { createAsyncThunk } from '@reduxjs/toolkit';
import { type HistoryError, type MatchHistoryResponse } from '../api/history-games.types';
import { axiosInstance } from '@/shared/api/instance';

export const fetchMatchHistory = createAsyncThunk(
  'history/fetchMatchHistory',
  async (page: number = 1, thunkAPI) => {
    try {
      const response = await axiosInstance.get<MatchHistoryResponse>(
        `/app/history/matches?page=${page}`,
      );
      return {
        items: response.data.items,
        links: response.data.links,
        meta: response.data.meta,
      };
    } catch (error: any) {
      return thunkAPI.rejectWithValue({
        message: error.response?.data?.message || error.message,
        code: error.response?.status || 500,
      } as HistoryError);
    }
  },
);

// import { createAsyncThunk } from '@reduxjs/toolkit';
// import {
//   type HistoryError,
//   type MatchHistoryResponse,
//   type WinCase,
// } from '../api/history-games.types';

// export const fetchMatchHistory = createAsyncThunk(
//   'history/fetchMatchHistory',
//   async (page: number = 1, thunkAPI) => {
//     try {
//       // Моковые данные
//       const mockHistoryData: MatchHistoryResponse = {
//         items: [
//           {
//             matchId: '1',
//             role: 'MAFIA',
//             rating: 15,
//             winCase: 'MAFIA_WIN',
//             date: '2023-05-15',
//             isWin: true,
//             location: 'Клуб "Ночной дозор"',
//             humanRole: 'Мафия',
//           },
//           {
//             matchId: '2',
//             role: 'CIVILIAN',
//             rating: -5,
//             winCase: 'MAFIA_WIN',
//             date: '2023-05-14',
//             isWin: false,
//             location: 'Клуб "Рассвет"',
//             humanRole: 'Мирный житель',
//           },
//           {
//             matchId: '3',
//             role: 'SHERIFF',
//             rating: 20,
//             winCase: 'CIVILIANS_WIN',
//             date: '2023-05-13',
//             isWin: true,
//             location: 'Клуб "Темная сторона"',
//             humanRole: 'Шериф',
//           },
//           {
//             matchId: '4',
//             role: 'DON',
//             rating: 10,
//             winCase: 'DRAW',
//             date: '2023-05-12',
//             isWin: false,
//             location: 'Клуб "Ночной дозор"',
//             humanRole: 'Дон мафии',
//           },
//           {
//             matchId: '5',
//             role: 'CIVILIAN',
//             rating: 5,
//             winCase: 'CIVILIANS_WIN',
//             date: '2023-05-11',
//             isWin: true,
//             location: 'Клуб "Рассвет"',
//             humanRole: 'Мирный житель',
//           },
//           {
//             matchId: '6',
//             role: 'MAFIA',
//             rating: -10,
//             winCase: 'CIVILIANS_WIN',
//             date: '2023-05-10',
//             isWin: false,
//             location: 'Клуб "Темная сторона"',
//             humanRole: 'Мафия',
//           },
//           {
//             matchId: '7',
//             role: 'ANARCHIST',
//             rating: 25,
//             winCase: 'ANARCHIST_WIN',
//             date: '2023-05-09',
//             isWin: true,
//             location: 'Клуб "Ночной дозор"',
//             humanRole: 'Анархист',
//           },
//           {
//             matchId: '8',
//             role: 'WEREWOLF',
//             rating: 30,
//             winCase: 'WEREWOLF_WIN',
//             date: '2023-05-08',
//             isWin: true,
//             location: 'Клуб "Рассвет"',
//             humanRole: 'Оборотень',
//           },
//           {
//             matchId: '9',
//             role: 'DOCTOR',
//             rating: 15,
//             winCase: 'CIVILIANS_WIN',
//             date: '2023-05-07',
//             isWin: true,
//             location: 'Клуб "Темная сторона"',
//             humanRole: 'Доктор',
//           },
//           {
//             matchId: '10',
//             role: 'MAFIA',
//             rating: -15,
//             winCase: 'CIVILIANS_WIN',
//             date: '2023-05-06',
//             isWin: false,
//             location: 'Клуб "Ночной дозор"',
//             humanRole: 'Мафия',
//           },
//         ],
//         links: {
//           self: { href: `/app/history/matches?page=${page}` },
//           first: { href: '/app/history/matches?page=1' },
//           last: { href: '/app/history/matches?page=3' },
//           prev: page > 1 ? { href: `/app/history/matches?page=${page - 1}` } : null,
//           next: page < 3 ? { href: `/app/history/matches?page=${page + 1}` } : null,
//         },
//         meta: {
//           totalCount: 30,
//           pageCount: 3,
//           currentPage: page,
//           perPage: 10,
//         },
//       };

//       // Имитация задержки сети
//       await new Promise((resolve) => setTimeout(resolve, 500));

//       return {
//         items: mockHistoryData.items,
//         links: mockHistoryData.links,
//         meta: mockHistoryData.meta,
//       };
//     } catch (error: any) {
//       return thunkAPI.rejectWithValue({
//         message: error.message,
//         code: 500,
//       } as HistoryError);
//     }
//   },
// );
